import React from 'react';
import PropTypes from 'prop-types';
import { StyledTextarea } from 'modules/styled/web';
import { LinkFont, SecondaryText, View } from 'modules/styled';

export const ReduxFormTextArea = (props) => {
  const { label, input, type, meta, name, placeholder, autocomplete } = props;
  const { dirty, touched, error, warning } = meta;
  return (
    <View sx={{ mt: 3 }}>
      {label ? (
        <label html-for={name}>
          <LinkFont sx={{ color: 'black' }}>{label}</LinkFont>
        </label>
      ) : null}
      <StyledTextarea
        {...input}
        placeholder={placeholder || label}
        autoComplete={autocomplete}
        name={name}
        type={type}
        border={1}
        p="2 2"
        mt={1}
      />
      {(dirty || touched) &&
        ((error && (
          <SecondaryText sx={{ color: 'red', mt: 4.001 }}>{error}</SecondaryText>
        )) ||
          (warning && <SecondaryText sx={{ color: 'red' }}>{warning}</SecondaryText>))}
    </View>
  );
};

ReduxFormTextArea.propTypes = {
  error: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  placeholder: PropTypes.string,
  meta: PropTypes.object,
  input: PropTypes.object,
  autocomplete: PropTypes.string,
};

ReduxFormTextArea.defaultProps = {
  autocomplete: null,
};
